import React from 'react';
import { Typography } from '@mui/material';

const EmailTemplates = () => (
  <div>
    <Typography variant="h6" sx={{ mb: 2 }}>Email Templates</Typography>

  </div>
);

export default EmailTemplates;